import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {useDispatch as useStoreDispatch} from "react-redux";
import auth from "./api/authSlice";
import {employeeApi} from "./api/employeeApi";
import {redirectApi} from "./api/redirectApi";

// Reducers
export const reducer = combineReducers({
    [employeeApi.reducerPath]: employeeApi.reducer,
    [redirectApi.reducerPath]: redirectApi.reducer,
    auth
})

export type StoreState = ReturnType<typeof reducer>
export type AppDispatch = typeof store.dispatch

export const useDispatch = () => useStoreDispatch<AppDispatch>()

export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({immutableCheck: false})
        .concat(employeeApi.middleware)
        .concat(redirectApi.middleware)
})